import {get, post} from "./Network";
import {logout as logoutAction} from "../actions/auth";
import store from '../store/store';

export const getToken = () => {
    return localStorage.getItem('token');
};

export const setToken = (token) => {
    return localStorage.setItem('token', token);
};

export const logout = () => {
    store.dispatch(logoutAction());
};

export const getProfile = () => {
    return get('/profile', {}, { showLoading: false });
};
export const saveProfile = (data) => {
    return post('/profile', data);
};

export const login = (data) => {
    return post('/auth/login', data, {loadingText: 'Ingresando...'});
};

export const forgotPassword = (data) => {
    return post('/auth/forgot-password', data, {loadingText: 'Enviando...'});
};

export const setPassword = (data) => {
    return post('/auth/set-password', data);
};
export const validateEmail = (data) => {
    return post('/auth/validate-email', data);
};
